import { jwtDecode } from 'jwt-decode';
import { fetchEmailData } from './service';

const whoamiUrl =
  process.env.REACT_APP_WHOAMI_INITIAL_CHECK_URL || 'https://wami-v2.phishcloud.io/api/initial_check';

/**
 * Validate an email against the Whoami initial_check API.
 *
 * @param {string} email - Normalized email address.
 * @returns {Promise<{ valid: boolean }>}
 *   Resolves with `{ valid: true }` when the email is registered,
 *   or `{ valid: false }` when it is not (status_code 400 or invalid token payload).
 */
export default async function validateEmail(email) {
  const response = await fetchEmailData(whoamiUrl, { email });
  const token = response.response;
  try {
    const decodedPayload = jwtDecode(token);
    if (decodedPayload.status_code === 400) {
      return { valid: false };
    }
    return { valid: true };
  } catch (error) {
    return { valid: false };
  }
}
